/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../common/handleKeyPress';
import HorizontalRule from '../HorizontalRule';
import Button from '../Button';
import * as Styled from './styles';

const PanelItem = ({ title, tooltip, showWarning, children, animationDelay, maxHeight, margin }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <Styled.ItemContainer margin={margin}>
            <Styled.ItemHeaderContainer
                data-test-id={`${title}-panel-item`}
                onClick={() => setIsCollapsed(!isCollapsed)}
                onKeyDown={(e) => handleKeyPress(e, () => setIsCollapsed(!isCollapsed))}
                role="button"
                aria-label={`${isCollapsed ? 'Expand' : 'Collapse'} Gmail truncation warning`}
            >
                <Styled.ItemHeaderTextContainer>
                    <Styled.ItemHeaderText>{title}</Styled.ItemHeaderText>
                    <Button
                        label={tooltip}
                        type="simple"
                        width={24}
                        icon={isCollapsed ? (showWarning ? 'times-circle' : 'exclamation-circle') : 'question-circle'}
                        color={isCollapsed ? (showWarning ? '#E82E41' : '#EC7100') : '#0277BD'}
                        hasHoverEffects={false}
                        iconSize={14}
                        tooltipTextAlign="left"
                        iconPadding={3}
                        marginBottom={0}
                        tooltipPadding="9px 6px"
                    />
                </Styled.ItemHeaderTextContainer>

                <Button
                    label="Toggle List"
                    type="simple"
                    width={24}
                    icon={isCollapsed ? 'chevron-down' : 'chevron-up'}
                    iconSize={14}
                    color="#656566"
                    tooltipTextAlign="left"
                    hasTooltip={false}
                    hasHoverEffects={false}
                    iconPadding={0}
                    marginBottom={0}
                />
            </Styled.ItemHeaderContainer>
            <HorizontalRule styling={{ marginBottom: 2 }} />
            <Styled.ItemContent isCollapsed={isCollapsed} animationDelay={animationDelay} maxHeight={maxHeight}>
                {children}
            </Styled.ItemContent>
        </Styled.ItemContainer>
    );
};

PanelItem.defaultProps = {
    animationDelay: 0.5,
    maxHeight: 200,
    margin: '20px 0',
};

PanelItem.propTypes = {
    title: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
    showWarning: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    animationDelay: PropTypes.number,
    maxHeight: PropTypes.number,
    margin: PropTypes.string,
};

export default PanelItem;
